export class EmailConfig {
    public id: number;
    public email?: string;
    public report?: number;
    public error?: number;
    public alert?: number;
    public rekbot_id?: number;

    constructor(
        id: number, 
        email: string, 
        report: number,
        error: number,
        alert: number,
        rekbot_id?: number
        ) {
        this.id = id;
        this.email = email;
        this.report = report;
        this.error = error;
        this.alert = alert;
        this.rekbot_id = rekbot_id;
    }
}